"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AttendeeTicketNotification = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Event = require("../context/Event");

var _hooks = require("../hooks");

var _orders = require("../lib/orders");

var _dates = require("../lib/dates");

var _Notification = _interopRequireDefault(require("../components/Notification"));

var _NotificationRenderer = _interopRequireDefault(require("../components/NotificationRenderer"));

var _AttendeeTicketNotificationContent = _interopRequireDefault(require("../components/AttendeeTicketNotificationContent"));

require("./AttendeeTicketNotification.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var shouldBannerRender = function shouldBannerRender(localizedEventStart, hasOrdersAndisLiveEvent) {
  if (!localizedEventStart) {
    return false;
  }

  return localizedEventStart || hasOrdersAndisLiveEvent;
};

var AttendeeTicketNotification = function AttendeeTicketNotification(props) {
  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      shouldRender = _useState2[0],
      setRender = _useState2[1];

  var userData = (0, _hooks.useAttendeeData)({
    hoursAheadPreview: props.hoursAheadPreview || 6,
    isAuthenticated: props.isAuthenticated
  });

  var _ref = userData ? userData.userOrders : [],
      _ref2 = _slicedToArray(_ref, 1),
      _ref2$ = _ref2[0],
      upcomingOrder = _ref2$ === void 0 ? {} : _ref2$;

  var _getEventInfoFromOrde = (0, _orders.getEventInfoFromOrder)(upcomingOrder),
      eventId = _getEventInfoFromOrde.eventId,
      ctaLinkUrl = _getEventInfoFromOrde.ctaLinkUrl,
      eventName = _getEventInfoFromOrde.eventName,
      hasDigitalContent = _getEventInfoFromOrde.hasDigitalContent,
      localizedEventStart = _getEventInfoFromOrde.start;

  var isEventLive = (0, _hooks.useIsLiveEvent)(localizedEventStart);
  /* If the event goes live. Set render state to true. This handles the
  case where the user dismisses the component but continues to stay on
  the page. */

  (0, _react.useEffect)(function () {
    if (isEventLive) {
      setRender(true);
    }
  }, [isEventLive]);

  if (!shouldRender || !localizedEventStart) {
    return null;
  }

  var handleClose = function handleClose() {
    setRender(false);
    props.onDismiss && props.onDismiss((0, _dates.getTimeUntilStart)(localizedEventStart), hasDigitalContent);
  };

  var handleLinkClick = function handleLinkClick() {
    props.onLinkClick && props.onLinkClick(eventId, hasDigitalContent);
  };

  return /*#__PURE__*/_react.default.createElement(_Event.LiveEventContext.Provider, {
    value: isEventLive
  }, /*#__PURE__*/_react.default.createElement(_NotificationRenderer.default, {
    domNode: props.domeNode,
    domNodeId: props.domNodeId
  }, /*#__PURE__*/_react.default.createElement(_Notification.default, {
    shouldAnimateEntry: props.shouldAnimateEntry,
    animateEntryDirection: props.animateEntryDirection,
    containerClasses: !hasDigitalContent ? "notification__physical-event ".concat(props.containerClasses) : props.containerClasses,
    containerStyles: props.containerStyles,
    onClose: handleClose,
    isNotDismissable: props.isNotDismissable
  }, /*#__PURE__*/_react.default.createElement(_AttendeeTicketNotificationContent.default, {
    eventStart: localizedEventStart,
    ctaLinkUrl: ctaLinkUrl,
    hasDigitalContent: hasDigitalContent,
    eventName: eventName,
    onLinkClick: handleLinkClick
  }))));
};

exports.AttendeeTicketNotification = AttendeeTicketNotification;
AttendeeTicketNotification.propTypes = {
  /*
   * Classes that will be applied to
   * the notification directly.
   */
  containerClasses: _propTypes.default.string,

  /*
   * Inline styles that will be applied
   * directly to the notification component.
   *
   * Useful for changing right or top offset
   * as your application needs
   */
  containerStyles: _propTypes.default.object,

  /*
   * Number of hours ahead an event
   * start that the notification should
   * be displayed. Defaults to 6
   */
  hoursAheadPreview: _propTypes.default.number,

  /*
   * If passed in, will render the notification
   * direclty as a child of the passed in dom
   * node.
   *
   * Value determined by domNodeId will take
   * precedence if both are defined.
   */
  domNode: _propTypes.default.node,

  /*
   * If passed in, will query the dom for
   * the ID and render the notification as
   * a direct child.
   *
   * domNodeId takes precedence if defined
   */
  domNodeId: _propTypes.default.string,

  /*
   * Makes it impossible to close the
   * modal and dismiss.
   */
  isNotDismissable: _propTypes.default.bool,

  /*
   * Optional boolean the consumer
   * can hydrate to prevent a
   * potentially unecessary api
   * call.
   */
  isAuthenticated: _propTypes.default.bool,

  /*
   * Callback triggered when
   * a user clicks on the CTA link
   *
   * Returns the EID of the active event
   */
  onLinkClick: _propTypes.default.func,

  /*
   * Callback triggered when the user
   * dismisses the notification
   *
   * Returns a diff of the current time
   * and event start time (ie time until start)
   */
  onDismiss: _propTypes.default.func,

  /*
   * Boolean which dictates if
   * the package should animate upon
   * mounting on the dom
   */
  shouldAnimateEntry: _propTypes.default.bool,

  /*
   * The direction that the notification should animate
   * upon mount.
   *
   * "left": animate moving from right to left
   * "right": animate moving left to right
   * "upwards": animate moving up
   * "downwards": animate moving down
   *
   * Defaults to "left"
   */
  animateEntryDirection: _propTypes.default.oneOf(['left', 'right', 'upwards', 'downwards'])
};
var _default = AttendeeTicketNotification;
exports.default = _default;
//# sourceMappingURL=AttendeeTicketNotification.js.map